export default function getUrl() {
  let url = "https://api.zayedluggagetracker.com/api/";
  // if (process.env.NODE_ENV === "development")
  //   url = "http://localhost:5000/api/"; 
  // else if (process.env.NODE_ENV === "production") {
  //   url = "https://api.zayedluggagetracker.com/api/";
  // }
  return url;
}
